module.exports = __webpack_public_path__ + "img/07岳晋琛.a991ef2e.png";